export default __webpack_public_path__ + "static/media/coverAbout2.e26275ee.jpg";